import toLower from 'lodash/toLower';
import get from 'lodash/get';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import { convertToPricision } from 'yoda-account-components/lib/common/aggregators/cancelOrderAgregator';
import {
    selectMarketplaceReturnItemsFiltered,
    selectMarketplaceReturnTotal,
} from '../selectors/marketplaceReturnSelectors';

class OrderActionFilter extends BaseActionFilter {
    analyticDetailsHelper(store, data) {
        const { context } = store.getState();

        let deviceType = '';
        if (context.deviceType.isMobile) {
            deviceType = 'mobile';
        } else if (context.deviceType.isDesktop) {
            deviceType = 'desktop';
        } else {
            deviceType = 'tablet';
        }

        const parsePageDL = this.updateCommonDigitalData();

        const pageInfo = {
            clusterInstance: Cookies.load('DPInstance'),
            deviceType,
            pageName: toLower(get(data, 'pageName', '')),
            pageType: 'account',
            releaseVersion: context.__RELEASEVERSION__,
            searchRedirect: '',
            siteSection: 'account',
            version: 'apollo 1 2017 redesign yoda post purchase',
        };

        const category = {
            department: 'account',
            primaryCategory: 'account',
            subCategory1: '',
            subCategory2: '',
        };

        const error = [];
        error.push({
            errorDescription: '',
        });

        return {
            ...parsePageDL,
            page: {
                ...parsePageDL.page,
                pageInfo: {
                    ...parsePageDL.page.pageInfo,
                    ...pageInfo,
                },
                category: {
                    ...parsePageDL.page.category,
                    ...category,
                },
            },
            error,
        };
    }

    getOrderPageDL(store, data) {
        const includePredefinedAnalytics = this.analyticDetailsHelper(store, data);
        const addCurbsideImpressions = {
            ...includePredefinedAnalytics,
            page: {
                ...includePredefinedAnalytics.page,
                pageInfo: {
                    ...includePredefinedAnalytics.page.pageInfo,
                    curbSideImpression: get(data, 'curbSideImpression', 'no'),
                    curbsideHowItWorksImpression: get(data, 'curbsideHowItWorksImpression', 'no'),
                },
            },
        };

        return addCurbsideImpressions;
    }

    getCurbsidePickupAnalyticsAction(store, data) {
        const includePredefinedAnalytics = this.analyticDetailsHelper(store, data);
        const curbsideCTAImpressions = {
            ...includePredefinedAnalytics,
            page: {
                ...includePredefinedAnalytics.page,
                pageInfo: {
                    ...includePredefinedAnalytics.page.pageInfo,
                    pageType: 'curbside pickup',
                    pageName: 'store selection',
                    curbsideStoreDetails: get(data, 'storeDetails', ''),
                },
            },
            product: get(data, 'productDetails', []),
        };

        return curbsideCTAImpressions;
    }

    getCurbsideStatusPageDetails(store, data) {
        const includePredefinedAnalytics = this.analyticDetailsHelper(store, data);
        const curbsideCTAImpressions = {
            ...includePredefinedAnalytics,
            page: {
                ...includePredefinedAnalytics.page,
                pageInfo: {
                    ...includePredefinedAnalytics.page.pageInfo,
                    curbsideCarColor: get(data, 'curbsideCarColor', ''),
                    curbsideCarSlot: get(data, 'curbsideCarSlot', '0'),
                    curbsideStoreid: get(data, 'curbsideStoreid', ''),
                    curbsideStatus: get(data, 'curbsideStatus', ''),
                    pageName: 'pickup process',
                    pageType: 'curbside pickup',
                    requestID: get(data, 'requestID', ''),
                },
            },
            user: {
                profile: {
                    profileInfo: {
                        curbsideStoreid: get(data, 'curbsideStoreid', ''),
                    },
                },
            },
            product: get(data, 'productDetails', []),
        };

        return curbsideCTAImpressions;
    }

    getMktPlcReturnDetails(store, data) {
        const includePredefinedAnalytics = this.analyticDetailsHelper(store, data);
        const { marketplaceReturn, orderDetails } = store.getState();
        let productList = [];
        if (marketplaceReturn?.items.length > 0) {
            productList = marketplaceReturn?.items.map((item) => {
                return {
                    productPPID: item?.product?.ppId,
                    mpSellername: item?.shopName,
                    productLotId: item?.product?.lotNumber,
                    productListPrice: item?.prices?.find((price) => price?.type === 'ORIGINAL')
                        ?.amount,
                };
            });
        }

        return {
            ...includePredefinedAnalytics,
            productList,
            linkName: 'Start a Return',
            orderId: orderDetails?.payload?.id,
        };
    }

    getMktPlcConfirmReturnDetails(store, data) {
        const includePredefinedAnalytics = this.analyticDetailsHelper(store, data);
        const state = store.getState();
        const { orderDetails } = state;
        const selectedItems = selectMarketplaceReturnItemsFiltered(state);
        const itemSum = selectMarketplaceReturnTotal(state);
        const refundSubtotal = convertToPricision(itemSum);
        let productList = [];
        if (selectedItems.length > 0) {
            productList = selectedItems.map((item) => {
                return {
                    productPPID: item?.product?.ppId,
                    mpSellername: item?.shopName,
                    productLotId: item?.product?.lotNumber,
                    productListPrice: item?.prices?.find((price) => price?.type === 'ORIGINAL')
                        ?.amount,
                    productReturnQuantity: item?.returnQuantity,
                    productReturnReason: item?.returnReason,
                };
            });
        }
        return {
            ...includePredefinedAnalytics,
            productList,
            linkName: 'Confirm Return',
            orderId: orderDetails?.payload?.id,
            refundAmount: refundSubtotal,
            numberOfItems: productList.length,
        };
    }
}

export default OrderActionFilter;
